// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__eDvxy","addWidgetButton":"Header_addWidgetButton__ah4BF","dashboardTabs":"Header_dashboardTabs__UqaLP","active":"Header_active__XGeUE"};